import React from 'react';
import Radium from 'radium';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const RPT = React.PropTypes;

@Radium
export default class WorkshopCategoryTile extends React.Component {
  static propTypes = {
    id: RPT.number.isRequired,
    color: RPT.string.isRequired,
    description: RPT.string.isRequired,
    icon_url: RPT.string.isRequired,
    name: RPT.string.isRequired,
    workshops: RPT.arrayOf(RPT.shape({
      id: RPT.number.isRequired,
      name: RPT.string.isRequired,
    })).isRequired
  }

  render() {
    const { description, name, color, icon_url, workshops, id } = this.props;
    const proppedStyles = styles({ color, icon_url });

    return (
      <div className="panel" style={proppedStyles.panel}>
        <div className="panel-heading" style={proppedStyles.heading}>
          {name}
        </div>
        <div className="panel-body" style={proppedStyles.body}>
          <div style={proppedStyles.description}>{description}</div>
          <div style={proppedStyles.workshops}>
            <strong>Workshopy:</strong> { workshops.length == 0 && <em>v přípravné fázi</em>}

            <ul style={proppedStyles.list}>
              {workshops.map(workshop =>
                <li key={`workshop-${workshop.id}`}>{workshop.name}</li>
              )}
            </ul>
          </div>

          { workshops.length > 0 &&
            <div>
              <LinkContainer to={`/workshopy/${id}`} style={proppedStyles.button}>
                <Button style={proppedStyles.button} bsStyle="default" bsSize="sm">Zjistit více</Button>
              </LinkContainer>
            </div>
          }
        </div>
      </div>
    );
  }
}

const styles = ({ color, icon_url: iconUrl }) => ({
  panel: {
    border: `1px solid ${color}`,
    minWidth: 260,
    maxWidth: '48%',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    width: '48%',
    margin: '1%',
    '@media (max-width: 571px)': {
      maxWidth: '100%',
    }
  },
  heading: {
    backgroundColor: color,
    fontWeight: 'bold',
    color: '#fff'
  },
  body: {
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    backgroundImage: `url(${iconUrl})`,
    backgroundSize: 75,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left bottom'
  },
  workshops: {
    flex: '1 0 auto',
    margin: '15px 0'
  },
  list: {
    listStyleType: 'circle'
  },
  button: {
    float: 'right',
    borderColor: color
  }
});



// WEBPACK FOOTER //
// ./src/browser/Feature/components/workshop_category_tile/index.jsx